import React, { useEffect, useState } from "react";
import "./InfographicRoadmapSimple.css";

const InfographicRoadmapSimple = () => {
  const [activeArticles, setActiveArticles] = useState(new Set());

  // Roadmap data from INFOGRAPHIC-CONTENT-EXTRACTION.md
  const roadmapData = [
    // GENESIS SECTION (Red Theme)
    {
      id: 1,
      section: "genesis",
      title: "Genesis Collection Launch",
      description:
        "Launch of our 2000 unique gemstone sailing ships on XRPL. Each ship crafted with distinct personality, rich backstory, and stunning AI-driven artistry. 30 gemstone ships are already live with XRPL minting active and community building in progress.",
      icon: "fa-ship",
      color: "danger",
    },
    {
      id: 2,
      section: "genesis",
      title: "Foundation Development",
      description:
        "Building the technical foundation with XRPL integration and establishing the visual identity of our gemstone sailing universe. Website & brand launch, XRPL smart contracts, and AI art pipeline are already completed.",
      icon: "fa-hammer",
      color: "danger",
    },
    {
      id: 3,
      section: "genesis",
      title: "Immersive Lore Creation",
      description:
        "Rich storytelling content creation with narrative videos and ship backstories for deep community engagement. Development of ship story videos, interactive lore hub, and community-generated stories to build our universe.",
      icon: "fa-book-open",
      color: "danger",
    },
    {
      id: 4,
      section: "genesis",
      title: "Narrative Expansion",
      description:
        "Creating rich backstories for each ship and developing the mythology of our sailing universe. Individual ship lore, video content creation, and comprehensive mythology development to enhance collector engagement.",
      icon: "fa-scroll",
      color: "danger",
    },
    {
      id: 5,
      section: "genesis",
      title: "Animated Airdrops",
      description:
        "Exclusive animated NFT airdrops for Genesis holders, bringing ships to life with motion and magic. Animated ship variants, holder-only drops, and special abilities to reward our early supporters and community.",
      icon: "fa-parachute-box",
      color: "danger",
    },
    // EXPANSION SECTION (Warning/Yellow Theme)
    {
      id: 6,
      section: "expansion",
      title: "Motion Magic",
      description:
        "Development of animated versions with enhanced visual effects, weather systems, and magical elements. Animation production, weather effects, and magical enhancements to bring ships to life in stunning detail.",
      icon: "fa-wand-magic-sparkles",
      color: "warning",
    },
    {
      id: 7,
      section: "expansion",
      title: "Social Platform",
      description:
        "Cross-platform community hub connecting art with narrative, enabling deeper engagement and collaboration. Community platform development, social integration, and exclusive member benefits for collectors.",
      icon: "fa-users",
      color: "warning",
    },
    {
      id: 8,
      section: "expansion",
      title: "Digital Legacy",
      description:
        "Establishing long-term digital legacy systems and cross-platform integration for lasting community value. Legacy systems, cross-platform tools, and value enhancement mechanisms for sustained growth.",
      icon: "fa-server",
      color: "warning",
    },
    {
      id: 9,
      section: "expansion",
      title: "New Voyages Begin",
      description:
        "Expansion into new ship classes, exploration routes, and adventures across the gemstone seas. New ship classes, exploration mechanics, and adventure quests to expand the sailing universe.",
      icon: "fa-compass",
      color: "warning",
    },
    {
      id: 10,
      section: "expansion",
      title: "Infinite Seas Discovery",
      description:
        "Opening new territories in the gemstone seas with unique challenges, treasures, and legendary ship encounters. New territories exploration, legendary encounters, and treasure systems await brave sailors.",
      icon: "fa-map",
      color: "warning",
    },
    // FUTURE VOYAGES SECTION (Purple Theme)
    {
      id: 11,
      section: "future",
      title: "Advanced Features",
      description:
        "Implementation of advanced blockchain features and interoperability with other platforms. Smart contract upgrades, cross-chain compatibility, and enhanced utility functions for ship holders.",
      icon: "fa-microchip",
      color: "purple",
    },
    {
      id: 12,
      section: "future",
      title: "Metaverse Integration",
      description:
        "Integration with virtual worlds and metaverse platforms, allowing ship owners to display and interact with their collections in 3D environments and virtual exhibitions.",
      icon: "fa-cube",
      color: "purple",
    },
    {
      id: 13,
      section: "future",
      title: "AI Companion System",
      description:
        "Intelligent AI companions for each ship that learn from owner interactions, provide personalized experiences, and assist in navigation through the expanding gemstone universe.",
      icon: "fa-robot",
      color: "purple",
    },
    {
      id: 14,
      section: "future",
      title: "Global Tournaments",
      description:
        "Competitive sailing tournaments with real prizes, seasonal events, and leaderboards. Ship owners can compete in various challenges and earn exclusive rewards and recognition.",
      icon: "fa-trophy",
      color: "purple",
    },
    {
      id: 15,
      section: "future",
      title: "VR Experiences",
      description:
        "Immersive virtual reality experiences allowing owners to step aboard their ships and explore the gemstone seas firsthand. VR galleries, immersive storytelling, and first-person sailing adventures.",
      icon: "fa-vr-cardboard",
      color: "purple",
    },
    {
      id: 16,
      section: "future",
      title: "Infinite Possibilities",
      description:
        "The ultimate realization of our gemstone sailing universe with unlimited potential for growth, innovation, and community-driven development. The journey never ends in the infinite seas.",
      icon: "fa-star",
      color: "purple",
    },
  ];

  // Handle article clicks
  const handleArticleClick = (step) => {
    setActiveArticles((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(step)) {
        newSet.delete(step);
      } else {
        newSet.add(step);
      }
      return newSet;
    });
  };

  // Handle navigation button clicks
  const handleNavigation = (e, currentStep, isPrev) => {
    e.preventDefault();
    e.stopPropagation();

    const nextStep = isPrev ? currentStep - 1 : currentStep + 1;
    if (nextStep >= 1 && nextStep <= 16) {
      setActiveArticles(new Set([nextStep]));

      // Scroll to the next article
      setTimeout(() => {
        const nextArticle = document.querySelector(`[data-step="${nextStep}"]`);
        if (nextArticle) {
          nextArticle.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }, 100);
    }
  };

  // Handle clicks outside articles to close them
  useEffect(() => {
    const handleClickOutside = (e) => {
      const articles = document.querySelectorAll("article.active");
      articles.forEach((article) => {
        if (article.contains(e.target) || article === e.target) return;
        const step = parseInt(article.getAttribute("data-step"));
        setActiveArticles((prev) => {
          const newSet = new Set(prev);
          newSet.delete(step);
          return newSet;
        });
      });
    };

    document.addEventListener("mouseup", handleClickOutside);
    return () => document.removeEventListener("mouseup", handleClickOutside);
  }, []);

  // Group roadmap data by sections
  const genesisItems = roadmapData.filter((item) => item.section === "genesis");
  const expansionItems = roadmapData.filter((item) => item.section === "expansion");
  const futureItems = roadmapData.filter((item) => item.section === "future");

  return (
    <div className="h-100 w-100 py-4">
      <div className="d-flex justify-content-center align-items-center flex-column mb-4">
        <h1 className="mb-2 text-white text-center">Sailing Ships Voyage Map</h1>
        <p className="w-75 text-white text-center">
          Embark on an epic journey through the gemstone seas with our comprehensive roadmap. Each phase brings new
          adventures, enhanced features, and deeper community engagement as we build the ultimate NFT sailing
          experience.
        </p>
      </div>

      <main id="infographic" className="d-flex flex-column align-items-center py-5">
        {/* GENESIS SECTION - Red Section */}
        <section className="step one text-danger">
          <div className="circle">
            <i className="fa-solid fa-map display-1 mb-3"></i>
            <h4>GENESIS</h4>
            Foundation & Launch
          </div>

          {genesisItems.map((item) => (
            <article
              key={item.id}
              data-step={item.id}
              className={activeArticles.has(item.id) ? "active" : ""}
              onClick={() => handleArticleClick(item.id)}
            >
              <header className="d-flex align-items-center bg-danger bg-opacity-10">
                <i className={`fa-solid ${item.icon} bg-danger`}></i>
                <h6 className="text-uppercase my-3 ps-4">{item.title}</h6>
              </header>

              <div className="body">
                <small>{item.description}</small>

                <div className="d-flex justify-content-between mt-3 controls">
                  <button
                    className={`btn btn-outline-danger ${item.id === 1 ? "invisible" : ""}`}
                    onClick={(e) => handleNavigation(e, item.id, true)}
                    type="button"
                  >
                    Prev
                  </button>
                  <button
                    className={`btn btn-outline-danger ${item.id === 5 ? "invisible" : ""}`}
                    onClick={(e) => handleNavigation(e, item.id, false)}
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
            </article>
          ))}
        </section>

        {/* EXPANSION SECTION - Yellow Section */}
        <section className="step two text-warning">
          <div className="circle">
            <i className="fa-solid fa-sun display-1 mb-3"></i>
            <h4>EXPANSION</h4>
            Community & Content
          </div>

          {expansionItems.map((item) => (
            <article
              key={item.id}
              data-step={item.id}
              className={activeArticles.has(item.id) ? "active" : ""}
              onClick={() => handleArticleClick(item.id)}
            >
              <header className="d-flex align-items-center text-warning bg-warning bg-opacity-10">
                <i className={`fa-solid ${item.icon} bg-warning`}></i>
                <h6 className="text-uppercase my-3 pe-4">{item.title}</h6>
              </header>

              <div className="body">
                <small>{item.description}</small>

                <div className="d-flex justify-content-between mt-3 controls">
                  <button className="btn btn-outline-warning" onClick={(e) => handleNavigation(e, item.id, true)} type="button">
                    Prev
                  </button>
                  <button className="btn btn-outline-warning" onClick={(e) => handleNavigation(e, item.id, false)} type="button">
                    Next
                  </button>
                </div>
              </div>
            </article>
          ))}
        </section>

        {/* FUTURE SECTION - Purple Section */}
        <section className="step three text-purple">
          <div className="circle">
            <i className="fa-solid fa-compass display-1 mb-3"></i>
            <h4>INFINITE</h4>
            Future Voyages
          </div>

          {futureItems.map((item) => (
            <article
              key={item.id}
              data-step={item.id}
              className={activeArticles.has(item.id) ? "active" : ""}
              onClick={() => handleArticleClick(item.id)}
            >
              <header className="d-flex align-items-center text-purple bg-purple bg-opacity-10">
                <i
                  className={`fa-solid ${item.icon} ${item.id === 16 ? "bg-purple display-2 p-4" : "bg-purple px-3"}`}
                ></i>
                <h6 className="text-uppercase my-3 ps-4">{item.title}</h6>
              </header>

              <div className="body">
                <small>{item.description}</small>

                <div className="d-flex justify-content-between mt-3 controls">
                  <button className="btn btn-outline-purple" onClick={(e) => handleNavigation(e, item.id, true)} type="button">
                    Prev
                  </button>
                  <button
                    className={`btn btn-outline-purple ${item.id === 16 ? "invisible" : ""}`}
                    onClick={(e) => handleNavigation(e, item.id, false)}
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
            </article>
          ))}
        </section>
      </main>
    </div>
  );
};

export default InfographicRoadmapSimple;
